<template>
    <div class="popup active">
        <div class="notice_popup evl_item unit">
            <div class="close" @click="$emit('close')">
                <img src="/images/close.png" alt="닫기"/>
            </div>
            <div class="tit" v-if="this.elemDetail.abilElemSeq == ''" >능력단위요소 등록</div>
            <div class="tit" v-else >능력단위요소 수정</div>
            <div class="item_box">
                <div class="label ivl12">중 분 류 명</div><div class="detail">{{pop.midClassNm}}</div>
                <div class="label ivl12">소 분 류 명</div><div class="detail">{{pop.minorClassNm}}</div>
                <div class="label ivl12">세 분 류 명</div><div class="detail">{{pop.detailClassNm}}</div>
                <div class="label ivl14">능력단위명</div><div class="detail">{{pop.abilUnitNm}}</div>
                <div class="label ivl18">능력단위요소코드</div><div class="detail">{{elemDetail.abilUnitElemCd}}</div>
                <div class="label ivl08">능력단위요소명</div><div class="detail">{{elemDetail.abilUnitElemNm}}</div>
                <div class="label ivl12">사 용 여 부</div><div class="detail">{{elemDetail.useYn}}</div>
            </div>
            <div class="member" v-if="this.elemDetail.abilElemSeq == ''">입력하신 내용으로 등록하시겠습니까?</div>
            <div class="member" v-else >입력하신 내용으로 수정하시겠습니까?</div>
            <div class="select-btn">
                <div class="btn" @click="$emit('close')">취소</div>
                <div class="btn" @click="$emit('close', true)">예</div> 
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props : ['param'],
    data() {
        return {
            pop : {},
            elemDetail : this.param.elemDetail,
            elemPopSeq : this.param.abilElemSeq,
        }
    },

    mounted() {
        //console.log('param', this.param);

        this.$.httpPost("/api/main/adm/ncsinout/getAbilUnitElemPop", { elemPopSeq: this.elemPopSeq })
                .then(res => {
                //console.log("getAbilUnitPop Result", res);
                this.pop = res.data.abilElemPop;
                // console.log('real?' , this.elemDetail);
            }).catch(this.$.httpErrorCommon);
    }
}
</script>